import dayjs from 'dayjs';
import { MyThermostat } from '../types';

export function formatHoldEnd(t: MyThermostat): string {
  return t?.getHoldEnd && t.getHoldEnd > -1
    ? dayjs(t?.getHoldEnd).fromNow()
    : 'Not supported';
}
